/**
 * @generated SignedSource<<89300a91ea5488bd2831fefb7dd52bc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContinueOldPlanInput = {
  cancel_url?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  success_url?: string | null | undefined;
};
export type ProUpgradeCardContinueOldPlanMutation$variables = {
  input: ContinueOldPlanInput;
};
export type ProUpgradeCardContinueOldPlanMutation$data = {
  readonly continueOldPlan: {
    readonly sessionId: string;
  } | null | undefined;
};
export type ProUpgradeCardContinueOldPlanMutation = {
  response: ProUpgradeCardContinueOldPlanMutation$data;
  variables: ProUpgradeCardContinueOldPlanMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ContinueOldPlanPayload",
    "kind": "LinkedField",
    "name": "continueOldPlan",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sessionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProUpgradeCardContinueOldPlanMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProUpgradeCardContinueOldPlanMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c5ba82f809c4296c2b3cbd3040a59a36",
    "id": null,
    "metadata": {},
    "name": "ProUpgradeCardContinueOldPlanMutation",
    "operationKind": "mutation",
    "text": "mutation ProUpgradeCardContinueOldPlanMutation(\n  $input: ContinueOldPlanInput!\n) {\n  continueOldPlan(input: $input) {\n    sessionId\n  }\n}\n"
  }
};
})();

(node as any).hash = "68154264562e76d9364d1410aee09e04";

export default node;
